import moment from 'moment'
import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux'
import buildDialogReducer from './buildDialogReducer'
import { dateToString } from '../../utils/dateUtils'

const dashboardVisitDialogReducer = buildDialogReducer('DASHBOARD_VISIT')
const dashboardRoomDialogReducer = buildDialogReducer('DASHBOARD_ROOM')

const dashboardPropsReducer = handleActions(
  {
    CHANGE_DASHBOARD_DATES: (state, action) => {
      return {
        ...state,
        startDate: dateToString(action.payload.startDate),
        endDate: dateToString(action.payload.endDate)
      }
    },
    CHANGE_DASHBOARD_SEARCH_TEXT: (state, action) => {
      return {
        ...state,
        searchText: action.payload
      }
    },
    CHANGE_DASHBOARD_PROGRAM_ROOM_VISIBILITY: (state, action) => {
      return {
        ...state,
        programRoomsVisible: action.payload
      }
    },
    GET_VISITS_START: (state, action) => {
      return {
        ...state,
        isLoading: state.isLoading + 1
      }
    },
    GET_VISITS_SUCCESS: (state, action) => {
      return {
        ...state,
        isLoading: state.isLoading - 1
      }
    },
    GET_VISITS_ERROR: (state, action) => {
      return {
        ...state,
        isLoading: state.isLoading - 1
      }
    }
  },
  {
    startDate: dateToString(moment().startOf('month')),
    endDate: dateToString(moment().endOf('month')),
    searchText: '',
    programRoomsVisible: false,
    isLoading: 0
  }
)

const dashboardReducer = combineReducers({
  props: dashboardPropsReducer,
  dialogs: combineReducers({
    visit: dashboardVisitDialogReducer,
    room: dashboardRoomDialogReducer
  })
})
export default dashboardReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/dashboardReducer.js